const gameConfig = {
  numDecks: 2, // Default number of decks used in the game
  allowDoubleDown: true,
  allowSplit: true,
  blackjackPayout: 1.2, // Payout for blackjack
  minBet: 5, // Minimum bet amount
  maxBet: 500, // Maximum bet amount
};

export default gameConfig;
